import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface OnDemandEventFormState {
  title: string;
  description: string;
  sports: string | string[];
  ageGroups: string[];
  isPaid: boolean;
  price: number;
  currency: string;
  online: boolean;
  onDemandLink: string;
  _id?: string;
}

interface OnDemandEventState {
  onDemandEventForm: OnDemandEventFormState;
}

export const initialState: OnDemandEventState = {
  onDemandEventForm: {
    title: '',
    description: '',
    sports: '',
    ageGroups: [],
    isPaid: false,
    price: 0,
    currency: 'EUR',
    online: true,
    onDemandLink: '',
    _id: undefined
  }
};

const eventSlice = createSlice({
  name: 'event',
  initialState: initialState,
  reducers: {
    setOnDemandEventFormData(
      state,
      action: PayloadAction<Partial<OnDemandEventFormState>>
    ) {
      state.onDemandEventForm = {
        ...state.onDemandEventForm,
        ...action.payload
      };
    },

    resetOnDemandEventFormData(state) {
      state.onDemandEventForm = {
        ...initialState.onDemandEventForm
      };
    }
  }
});

export const {setOnDemandEventFormData, resetOnDemandEventFormData} =
  eventSlice.actions;
export default eventSlice.reducer;
